/**
 * GENERATED by client/test/bake-hitvolumes.mts — do NOT hand-edit; re-run the bake
 * (`npm run bake:hitvolumes`).
 *
 * The sword's REAL blade path through each attack, in CHARACTER-LOCAL space (metres),
 * sampled across the action's active window. Client prediction (main.ts) and server
 * authority (rooms.ts applyMelee) sweep against this same data, so they cannot drift.
 *
 * The bake FAILS if a COMBAT_ACTIONS active window does not contain the blade's actual
 * sweep — so this data and that table cannot silently disagree.
 */
import type { HitArc } from "./hitVolume.js";

export const HIT_ARCS: Record<string, HitArc> = {
  sword_light_1: {
    radius: 0.5,
    samples: [
      { t: 0, base: [0.18747,1.1029,0.29033], tip: [0.57663,0.2425,0.22471] },
      { t: 0.15868, base: [0.10691,1.15525,0.37502], tip: [0.85431,0.64648,0.65536] },
      { t: 0.28137, base: [0.03667,1.23071,0.42168], tip: [0.79972,1.21274,0.98156] },
      { t: 0.41409, base: [0.08564,1.33084,0.43015], tip: [0.79812,1.73596,0.90374] },
      { t: 0.49475, base: [0.35688,1.35522,0.28581], tip: [1.22018,1.72723,0.39701] },
      { t: 0.55846, base: [0.48042,1.34029,0.04767], tip: [1.33656,1.62104,-0.24258] },
      { t: 0.61048, base: [0.46678,1.30762,-0.19122], tip: [1.12126,1.48459,-0.8518] },
      { t: 0.6628, base: [0.33606,1.28165,-0.39239], tip: [0.63241,1.38695,-1.2852] },
      { t: 0.7606, base: [0.10609,1.21148,-0.5078], tip: [0.01078,1.2325,-1.44934] },
      { t: 0.84748, base: [-0.09888,1.1255,-0.48619], tip: [-0.56152,0.9578,-1.29481] },
      { t: 0.9285, base: [-0.24323,1.04489,-0.37582], tip: [-0.97577,0.68697,-0.85678] },
      { t: 1, base: [-0.30636,0.99913,-0.21315], tip: [-1.13505,0.54204,-0.2327] },
    ],
  },
  sword_light_2: {
    radius: 0.5,
    samples: [
      { t: 0, base: [-0.36564,1.1977,0.08978], tip: [-0.16403,1.49576,0.96531] },
      { t: 0.434, base: [-0.39381,1.23629,0.04662], tip: [-0.27956,1.28293,0.98513] },
      { t: 0.51936, base: [-0.40295,1.21419,-0.13285], tip: [-0.85398,1.11586,0.69355] },
      { t: 0.58097, base: [-0.32652,1.20463,-0.30281], tip: [-1.14756,0.97902,0.11074] },
      { t: 0.62357, base: [-0.18128,1.20618,-0.42458], tip: [-1.06576,0.89158,-0.54607] },
      { t: 0.66484, base: [0.00214,1.21594,-0.47387], tip: [-0.64354,0.85201,-1.06267] },
      { t: 0.70503, base: [0.18838,1.23269,-0.444], tip: [-0.01488,0.86233,-1.29109] },
      { t: 0.74684, base: [0.35629,1.25753,-0.33068], tip: [0.63997,0.93007,-1.17231] },
      { t: 0.7889, base: [0.46222,1.28491,-0.15391], tip: [1.15059,1.02414,-0.74904] },
      { t: 0.83045, base: [0.48352,1.31245,0.04814], tip: [1.39455,1.13126,-0.13415] },
      { t: 0.87168, base: [0.41933,1.33947,0.23787], tip: [1.31751,1.24602,0.52174] },
      { t: 1, base: [0.26372,1.36546,0.39419], tip: [0.93245,1.33331,1.06338] },
    ],
  },
  sword_light_3: {
    radius: 0.5,
    samples: [
      { t: 0, base: [-0.05351,1.1829,0.41673], tip: [0.57263,0.63715,0.87076] },
      { t: 0.32182, base: [-0.14554,1.01505,0.23294], tip: [0.55226,1.10399,0.86634] },
      { t: 0.46472, base: [-0.27541,1.00533,0.04892], tip: [-0.22677,1.04254,0.99353] },
      { t: 0.50466, base: [-0.28507,1.03578,-0.22339], tip: [-0.74203,0.55667,0.45313] },
      { t: 0.53422, base: [-0.13943,1.14662,-0.40779], tip: [-0.7916,0.46098,-0.43234] },
      { t: 0.55889, base: [0.04791,1.31965,-0.43849], tip: [-0.37219,0.82954,-1.13083] },
      { t: 0.58402, base: [0.18844,1.49996,-0.31671], tip: [0.23228,1.47763,-1.26202] },
      { t: 0.61278, base: [0.30569,1.58187,-0.10654], tip: [0.83219,1.94448,-0.80464] },
      { t: 0.64201, base: [0.31151,1.60379,0.13858], tip: [1.04157,2.19658,0.03068] },
      { t: 0.68284, base: [0.1915,1.56776,0.34834], tip: [0.74329,2.14548,0.85608] },
      { t: 0.76541, base: [-0.01819,1.43488,0.45485], tip: [0.16828,1.66991,1.35264] },
      { t: 1, base: [-0.28696,1.29893,0.34153], tip: [-0.55965,1.19489,1.242] },
    ],
  },
  sword_light_4: {
    radius: 0.5,
    samples: [
      { t: 0, base: [0.00249,1.37764,0.34625], tip: [0.76548,1.66539,0.82696] },
      { t: 0.22026, base: [0.09521,1.36188,0.33405], tip: [0.92968,1.67646,0.65143] },
      { t: 0.32554, base: [0.19162,1.36186,0.3144], tip: [1.08552,1.62755,0.47684] },
      { t: 0.39708, base: [0.28362,1.36315,0.27382], tip: [1.20783,1.56771,0.27856] },
      { t: 0.46704, base: [0.36294,1.36095,0.21032], tip: [1.28465,1.51281,0.0573] },
      { t: 0.53569, base: [0.42419,1.35618,0.12842], tip: [1.3137,1.46463,-0.17661] },
      { t: 0.60325, base: [0.46353,1.34996,0.03367], tip: [1.29467,1.42479,-0.41312] },
      { t: 0.66995, base: [0.4788,1.34341,-0.06783], tip: [1.22911,1.39468,-0.64267] },
      { t: 0.74669, base: [0.47271,1.32733,-0.16845], tip: [1.12694,1.34245,-0.8524] },
      { t: 0.83196, base: [0.44526,1.30418,-0.26365], tip: [0.98916,1.27532,-1.03785] },
      { t: 0.91631, base: [0.39564,1.28463,-0.34957], tip: [0.81494,1.22564,-1.19618] },
      { t: 1, base: [0.32735,1.26978,-0.42137], tip: [0.61165,1.19492,-1.32115] },
    ],
  },
  sword_riposte: {
    radius: 0.5,
    samples: [
      { t: 0, base: [0.01546,1.61861,0.20631], tip: [-0.30746,2.46938,0.467] },
      { t: 0.28699, base: [-0.00715,1.69199,0.06444], tip: [-0.49401,2.50112,0.13006] },
      { t: 0.39881, base: [0.08436,1.71006,-0.03219], tip: [-0.23973,2.58051,-0.21475] },
      { t: 0.45773, base: [0.1553,1.66929,-0.20254], tip: [-0.01806,2.51876,-0.58251] },
      { t: 0.50071, base: [0.16453,1.57267,-0.37563], tip: [0.06892,2.31486,-0.95533] },
      { t: 0.54262, base: [0.11545,1.44412,-0.50914], tip: [0.01256,2.01096,-1.26024] },
      { t: 0.59134, base: [0.03643,1.29248,-0.58845], tip: [-0.12111,1.65158,-1.45] },
      { t: 0.67524, base: [0.00195,1.08509,-0.60691], tip: [-0.10889,1.22499,-1.53652] },
      { t: 0.74592, base: [-0.03076,0.92782,-0.56715], tip: [-0.10983,0.79229,-1.50064] },
      { t: 0.79627, base: [-0.0219,0.85396,-0.52134], tip: [-0.05057,0.38979,-1.34582] },
      { t: 0.84655, base: [-0.01519,0.79198,-0.46372], tip: [-0.00918,0.06035,-1.06432] },
      { t: 1, base: [-0.02158,0.73346,-0.39147], tip: [-0.00119,-0.16405,-0.69164] },
    ],
  },
  sword_launcher: {
    radius: 0.5,
    samples: [
      { t: 0, base: [-0.26618,0.97914,-0.01942], tip: [-0.34374,0.79919,0.90667] },
      { t: 0.05263, base: [-0.29026,1.08844,-0.21797], tip: [-0.82727,0.72704,0.47272] },
      { t: 0.10149, base: [-0.17285,1.25778,-0.35833], tip: [-0.97598,0.7896,-0.17992] },
      { t: 0.1561, base: [-0.01884,1.44463,-0.33129], tip: [-0.70511,0.96242,-0.77009] },
      { t: 0.23979, base: [0.06463,1.55869,-0.21576], tip: [-0.16466,1.22847,-1.07274] },
      { t: 0.3621, base: [0.15247,1.61515,-0.09882], tip: [0.39076,1.60579,-1.01488] },
      { t: 0.46581, base: [0.16699,1.65936,0.05922], tip: [0.69374,2.05601,-0.61992] },
      { t: 0.56254, base: [0.11685,1.65663,0.22106], tip: [0.72185,2.34671,-0.01086] },
      { t: 0.65686, base: [0.05809,1.58256,0.3629], tip: [0.57458,2.32273,0.64824] },
      { t: 0.74877, base: [-0.01747,1.45932,0.45232], tip: [0.29163,1.99554,1.16853] },
      { t: 0.85935, base: [-0.0681,1.30255,0.47643], tip: [0.0371,1.41804,1.41005] },
      { t: 1, base: [-0.11477,1.15554,0.42872], tip: [-0.22363,0.80332,1.30057] },
    ],
  },
  sword_air_1: {
    radius: 0.5,
    samples: [
      { t: 0, base: [0.06305,1.12105,0.24897], tip: [-0.11311,0.71876,1.08752] },
      { t: 0.28777, base: [0.172,1.0747,0.18941], tip: [0.36406,0.57971,0.97309] },
      { t: 0.39972, base: [0.25775,1.02658,0.12042], tip: [0.72368,0.39702,0.65203] },
      { t: 0.50414, base: [0.31101,0.98881,0.01632], tip: [0.9143,0.28063,0.19116] },
      { t: 0.56696, base: [0.30177,0.94679,-0.10678], tip: [0.81631,0.1773,-0.3047] },
      { t: 0.62904, base: [0.24989,0.93107,-0.22832], tip: [0.55115,0.19871,-0.74691] },
      { t: 0.69044, base: [0.16253,0.94489,-0.33132], tip: [0.17127,0.34565,-1.06404] },
      { t: 0.7513, base: [0.05136,0.98782,-0.40203], tip: [-0.25376,0.59999,-1.20982] },
      { t: 0.81205, base: [-0.09267,1.04741,-0.41724], tip: [-0.66715,0.90466,-1.15591] },
      { t: 0.87313, base: [-0.22135,1.13123,-0.37445], tip: [-0.97546,1.25402,-0.93327] },
      { t: 0.93545, base: [-0.31018,1.22928,-0.28094], tip: [-1.11957,1.61113,-0.58936] },
      { t: 1, base: [-0.33909,1.32893,-0.15381], tip: [-1.06324,1.93727,-0.19344] },
    ],
  },
  sword_air_2: {
    radius: 0.5,
    samples: [
      { t: 0, base: [-0.33104,1.24619,-0.20832], tip: [-0.67341,1.69742,0.55011] },
      { t: 0.12043, base: [-0.22676,1.20684,-0.36825], tip: [-0.98417,1.62669,0.01398] },
      { t: 0.23126, base: [-0.0458,1.18043,-0.46062], tip: [-0.90314,1.55585,-0.60222] },
      { t: 0.30784, base: [0.13193,1.12676,-0.46019], tip: [-0.55345,1.34184,-1.07666] },
      { t: 0.38019, base: [0.29766,1.08701,-0.37801], tip: [0.00492,1.13482,-1.27693] },
      { t: 0.44971, base: [0.41457,1.05786,-0.23188], tip: [0.59301,0.94798,-1.15499] },
      { t: 0.52263, base: [0.4589,1.04462,-0.04892], tip: [1.03401,0.76433,-0.74657] },
      { t: 0.59708, base: [0.42183,1.04037,0.13615], tip: [1.21164,0.61264,-0.16265] },
      { t: 0.67276, base: [0.3079,1.03702,0.28665], tip: [1.06246,0.48474,0.43381] },
      { t: 0.76385, base: [0.14638,1.0476,0.37785], tip: [0.64157,0.4316,0.89877] },
      { t: 0.86717, base: [-0.03336,1.06402,0.39425], tip: [0.04658,0.43283,1.09514] },
      { t: 1, base: [-0.19586,1.07053,0.3258], tip: [-0.55145,0.42117,0.91565] },
    ],
  },
  sword_gpound: {
    radius: 0.5,
    samples: [
      { t: 0, base: [-0.02032,1.0229,0.35447], tip: [0.22249,0.38021,1.00565] },
      { t: 0.02257, base: [0.12807,1.07198,0.35952], tip: [0.82831,0.7601,0.91488] },
      { t: 0.04329, base: [0.23689,1.19792,0.32534], tip: [1.09752,1.38372,0.67295] },
      { t: 0.06532, base: [0.27961,1.34903,0.23624], tip: [0.99262,1.97064,0.27166] },
      { t: 0.09474, base: [0.26923,1.51905,0.09599], tip: [0.54833,2.40439,-0.08922] },
      { t: 0.17368, base: [0.27085,1.56381,-0.34891], tip: [0.25924,2.49984,-0.48941] },
      { t: 0.22136, base: [0.3019,1.24967,-0.55386], tip: [0.37128,2.05391,-1.04824] },
      { t: 0.25715, base: [0.28373,0.96437,-0.5627], tip: [0.37523,1.41495,-1.39013] },
      { t: 0.28131, base: [0.25355,0.79748,-0.49855], tip: [0.38334,0.69353,-1.43042] },
      { t: 0.31339, base: [0.2204,0.6966,-0.40941], tip: [0.36922,0.05764,-1.09177] },
      { t: 0.86488, base: [0.23473,0.76571,-0.28794], tip: [0.32289,-0.0404,-0.77625] },
      { t: 1, base: [0.30938,0.97728,-0.00894], tip: [0.53061,0.06181,-0.10386] },
    ],
  },
  gs_light_1: {
    radius: 0.5,
    samples: [
      { t: 0, base: [-0.12417,0.93722,-0.23594], tip: [-0.71815,0.69345,0.45961] },
      { t: 0.46098, base: [-0.10238,0.95643,-0.32519], tip: [-0.79572,0.82915,0.30657] },
      { t: 0.53257, base: [-0.04118,0.99662,-0.38444], tip: [-0.85572,0.77743,0.0451] },
      { t: 0.58387, base: [0.00883,1.03829,-0.39855], tip: [-0.87544,0.74765,-0.2264] },
      { t: 0.62248, base: [0.04294,1.07701,-0.38681], tip: [-0.83155,0.73131,-0.49541] },
      { t: 0.6624, base: [0.07366,1.11995,-0.36848], tip: [-0.708,0.73547,-0.73891] },
      { t: 0.71054, base: [0.11985,1.18298,-0.36032], tip: [-0.5721,0.85077,-0.91428] },
      { t: 0.8018, base: [0.20558,1.32809,-0.31198], tip: [-0.43853,1.07699,-0.9586] },
      { t: 0.84931, base: [0.23946,1.40321,-0.26351], tip: [-0.22783,1.21173,-1.06414] },
      { t: 0.89266, base: [0.25491,1.47092,-0.20532], tip: [-0.02256,1.38695,-1.10642] },
      { t: 0.93853, base: [0.25166,1.52982,-0.14093], tip: [0.1607,1.58832,-1.08132] },
      { t: 1, base: [0.24176,1.55076,-0.10272], tip: [0.35472,1.76971,-1.01669] },
    ],
  },
  gs_light_2: {
    radius: 0.5,
    samples: [
      { t: 0, base: [0.35768,1.29361,0.17614], tip: [0.73369,1.28282,-0.69249] },
      { t: 0.12792, base: [0.28065,1.25067,0.17947], tip: [0.91194,1.01114,-0.48395] },
      { t: 0.25986, base: [0.20466,1.2384,0.16367], tip: [0.89012,0.71904,-0.23187] },
      { t: 0.40807, base: [0.14428,1.23549,0.13706], tip: [0.71733,0.48977,0.02959] },
      { t: 0.63799, base: [0.13836,1.20604,0.10341], tip: [0.70671,0.44918,0.09029] },
      { t: 0.72909, base: [0.1771,1.15449,0.06501], tip: [0.86074,0.57605,-0.24171] },
      { t: 0.79921, base: [0.19144,1.10971,0.00408], tip: [0.83858,0.73689,-0.57751] },
      { t: 0.85597, base: [0.17407,1.08587,-0.05674], tip: [0.63916,0.9091,-0.86202] },
      { t: 0.88455, base: [0.15775,1.05718,-0.14464], tip: [0.40079,1.14683,-1.0551] },
      { t: 0.91129, base: [0.10814,1.04551,-0.23985], tip: [0.17302,1.4567,-1.08999] },
      { t: 0.9421, base: [0.01912,1.06561,-0.32274], tip: [0.0564,1.78692,-0.93459] },
      { t: 1, base: [-0.09581,1.13549,-0.43446], tip: [-0.13578,2.01883,-0.77233] },
    ],
  },
  gs_light_3: {
    radius: 0.5,
    samples: [
      { t: 0, base: [0.02665,1.69517,-0.10604], tip: [-0.3889,2.40688,0.35959] },
      { t: 0.36573, base: [0.07166,1.68183,-0.17304], tip: [-0.47707,2.42026,0.04979] },
      { t: 0.42303, base: [0.10842,1.63539,-0.27025], tip: [-0.49245,2.36662,-0.2874] },
      { t: 0.47159, base: [0.13872,1.57528,-0.34044], tip: [-0.42392,2.28657,-0.61162] },
      { t: 0.51235, base: [0.15068,1.5093,-0.3864], tip: [-0.32672,2.14124,-0.90483] },
      { t: 0.55615, base: [0.16273,1.43184,-0.4182], tip: [-0.23568,1.90565,-1.13431] },
      { t: 0.63863, base: [0.1688,1.28557,-0.4354], tip: [-0.10688,1.6226,-1.2759] },
      { t: 0.71396, base: [0.20361,1.16734,-0.41689], tip: [0.01871,1.3105,-1.33415] },
      { t: 0.78686, base: [0.23425,1.04673,-0.32764], tip: [0.16775,1.01514,-1.27137] },
      { t: 0.86079, base: [0.25591,0.99647,-0.15572], tip: [0.30932,0.77916,-1.07548] },
      { t: 0.91324, base: [0.2654,1.01812,-0.04601], tip: [0.3833,0.53337,-0.85047] },
      { t: 1, base: [0.26665,1.07356,0.04615], tip: [0.45604,0.37076,-0.55903] },
    ],
  },
  gs_heavy: {
    radius: 0.5,
    samples: [
      { t: 0, base: [0.26283,1.53295,0.15777], tip: [0.53266,1.54613,-0.74946] },
      { t: 0.25837, base: [0.27538,1.52947,0.14361], tip: [0.54746,1.41055,-0.75521] },
      { t: 0.38567, base: [0.31367,1.51375,0.08666], tip: [0.51145,1.31658,-0.8178] },
      { t: 0.44904, base: [0.36651,1.46992,0.01215], tip: [0.40908,1.26015,-0.90993] },
      { t: 0.50357, base: [0.40182,1.41302,-0.06831], tip: [0.2874,1.2189,-0.9877] },
      { t: 0.53794, base: [0.41187,1.35942,-0.13225], tip: [0.14224,1.2254,-1.02967] },
      { t: 0.57404, base: [0.40581,1.30278,-0.19755], tip: [-0.00435,1.25397,-1.04927] },
      { t: 0.61779, base: [0.37967,1.24136,-0.28962], tip: [-0.12275,1.29455,-1.09011] },
      { t: 0.675, base: [0.30137,1.1776,-0.42451], tip: [-0.21009,1.29699,-1.21203] },
      { t: 0.7229, base: [0.23377,1.16031,-0.50176], tip: [-0.24072,1.22897,-1.31796] },
      { t: 0.77354, base: [0.17984,1.17319,-0.55658], tip: [-0.19839,1.12986,-1.42324] },
      { t: 1, base: [0.14378,1.1955,-0.59544], tip: [-0.16831,1.14682,-1.48778] },
    ],
  },
};
